import { Flex, FlexProps } from '@chakra-ui/react';
import { ActivityDetailsTabs } from './components/ActivityDetailsTabs';

const ActivityDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <ActivityDetailsTabs />
  </Flex>
);

export default ActivityDetailsData;
